import { Flex, Typography } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

type Props = {
  question: string;
};
export function DepreciationQuestion({ question, children }: PropsWithChildren<Props>) {
  return (
    <Flex flexDirection="column" gap=".5rem">
      <Typography variant="h3">{question}</Typography>
      <Flex paddingX="1rem">{children}</Flex>
    </Flex>
  );
}
